import React from 'react'
import Text from '@navent-jobs/ui-kit/components/text'
import { SearchStack } from '../../../../services/search-stack'
import { NOMBRE_PAIS } from '../../../../constants/index'
import { RecientesComponent, Heading, RecientesList, RecientesItem, RecientesLink, IconCaretRight } from './mixins'
import Placeholder from './placeholder'

export const BusquedasRecientes = ({ loading }) => {
  const lastSearches = SearchStack.getInstance().getHistory()

  if (loading) {
    return <Placeholder />
  }

  return (
    <RecientesComponent>
      <Heading>
        <Text size="lg" fontWeight="semibold" as="h3">
          Búsquedas recientes
        </Text>
      </Heading>
      <RecientesList>
        {lastSearches.length > 0 &&
          lastSearches.map(recentSearch => {
            const text = recentSearch?.busqueda?.value?.trim()
            return (
              text && (
                <RecientesItem>
                  <RecientesLink text={text} to={{ pathname: recentSearch.url }}>
                    {text}
                    <IconCaretRight name="icon-light-caret-right" color="rgba(0, 0, 24, 0.48);" size="16" />
                  </RecientesLink>
                </RecientesItem>
              )
            )
          })}
        <RecientesItem>
          <RecientesLink text={`Empleos en ${NOMBRE_PAIS}`} to={{ pathname: '/empleos.html' }}>
            Empleos en {NOMBRE_PAIS}
            <IconCaretRight name="icon-light-caret-right" color="rgba(0, 0, 24, 0.48);" size="16" />
          </RecientesLink>
        </RecientesItem>
      </RecientesList>
    </RecientesComponent>
  )
}
